import { connect } from 'react-redux';

import {
  exportQuestionsToCSV,
  importQuestionsFromCSV,
} from '../../../Books/actionsSagas';
import { getUser } from '../../../Login/selectors';
import { deleteTaskNotification } from './components/actionsSagas';
import Header from './Header';

const mapStateToProps = (state) => ({
  user: getUser(state),
});

const mapDispatchToProps = {
  deleteNotification: deleteTaskNotification,
  exportQuestionsToCSV,
  importQuestionsFromCSV,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
